module.exports = __webpack_public_path__ + "img/clipboard.7a0a7a01.svg";